import React, { Component } from "react";
import {
    Paper,
    Typography,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio
} from "@material-ui/core";
import { Modal } from "reactstrap";
import "./submittedReportsStyles.css";
export default class ChangeStatusModal extends Component {
    constructor(props) {
        super(props);
        this.state = { deleteTimestamp: false };
    }
    componentDidUpdat(prevProps, prevState) {}
    renderText = (key, label) => {
        const { modalData } = this.props;
        return (
            <div style={{ display: "flex", marginBottom: 15 }}>
                <Typography
                    variant="body1"
                    style={{ marginRight: 40, width: 150 }}
                >
                    <b>{label}:</b>
                </Typography>
                <Typography variant="body1">{modalData.plan[key]}</Typography>
            </div>
        );
    };
    render() {
        const {
            modalOpen,
            modalType,
            modalData,
            deleteReport,
            deleteAllReport,
            setModal
        } = this.props;

        return (
            <Modal isOpen={modalOpen}>
                {modalData && (
                    <Paper style={{ padding: 15 }}>
                        <Typography
                            style={{ marginBottom: 15 }}
                            variant="title"
                        >
                            {modalType === "delete"
                                ? "Delete Report"
                                : ""}
                            {modalType === "view"
                                ? "View Requested TM Plan"
                                : ""}
                            {modalType === "delete-all"
                                ? "Delete All Report"
                                : ""}
                        </Typography>
                        {modalType === "view" && (
                            <>
                                {this.renderText("lighting", "Lighting")}

                                {this.renderText(
                                    "maxSiteLength",
                                    "Max Site Distance"
                                )}
                                {this.renderText(
                                    "maxTrafficCount",
                                    "Max Traffic Count"
                                )}

                                {this.renderText(
                                    "minUnobstructedWidth",
                                    "Unobstructed Width"
                                )}
                                {this.renderText("roadType", "Road Type")}
                                {this.renderText("roadLayout", "Road Layout")}
                                {this.renderText("minVisibility", "Visibility")}
                                {this.renderText(
                                    "noAdvanceSigns",
                                    "No Advanced Signs"
                                )}
                                {this.renderText("roadPart", "Road Part")}
                                {this.renderText("roadwayWidth", "Road Width")}

                                {this.renderText("speed", "Speed")}
                                {this.renderText("signSize", "Sign Size")}

                                {this.renderText("time", "Time")}
                            </>
                        )}
                        {modalType === "delete" && (
                            <>
                                <Typography
                                    style={{ margin: 15 }}
                                    variant="body2"
                                >
                                    <b>
                                        This will delete this Request TM Plan
                                        data permanently!
                                    </b>
                                </Typography>
                                <FormControl
                                    component="fieldset"
                                    style={{ width: "100%" }}
                                >
                                    <FormLabel component="legend">
                                        Select Timestamp
                                    </FormLabel>
                                    <RadioGroup
                                        aria-label="timestamp"
                                        name="timestamps"
                                        value={this.state.deleteTimestamp}
                                        onChange={event => {
                                            this.setState({
                                                deleteTimestamp:
                                                    event.target.value
                                            });
                                        }}
                                    >
                                        {modalData.timestamps &&
                                            modalData.timestamps.map(e => {
                                                return (
                                                    <FormControlLabel
                                                        key={e}
                                                        value={e}
                                                        control={<Radio />}
                                                        label={e}
                                                    />
                                                );
                                            })}
                                    </RadioGroup>
                                </FormControl>
                            </>
                        )}

                        {modalType === "delete-all" && (
                            <>
                                <Typography
                                    style={{ margin: 15 }}
                                    variant="body2"
                                >
                                    <b>
                                        This will delete all Request TM Plan
                                        data permanently!
                                    </b>
                                </Typography>
                            </>
                        )}

                        <div style={{ float: "right", margin: 10 }}>
                            <Button
                                onClick={() => setModal(false, false, false)}
                                color={
                                    modalType === "deleted"
                                        ? "secondary"
                                        : "primary"
                                }
                                variant="contained"
                                style={{ marginRight: 5 }}
                            >
                                {modalType === "delete" ? "Cancel" : "Close"}
                            </Button>
                            {modalType === "delete" && (
                                <Button
                                    color={
                                        modalType === "deleted"
                                            ? "primary"
                                            : "secondary"
                                    }
                                    disabled={!this.state.deleteTimestamp}
                                    variant="contained"
                                    onClick={() => {
                                        deleteReport(
                                            this.state.deleteTimestamp
                                        );
                                        setModal(false, false, false);
                                    }}
                                >
                                    {modalType === "delete"
                                        ? "Delete"
                                        : "Update"}
                                </Button>
                            )}
                            {modalType === "delete-all" && (
                                <Button
                                    color={
                                        modalType === "deleted"
                                            ? "primary"
                                            : "secondary"
                                    }
                                    variant="contained"
                                    onClick={() => {
                                        deleteAllReport();
                                        setModal(false, false, false);
                                    }}
                                >
                                {modalType === "delete-all"
                                    ? "Delete"
                                    : ""}
                                </Button>
                            )}
                        </div>
                    </Paper>
                )}
            </Modal>
        );
    }
}
